import type {
  TaskDefinitionRequest,
  TaskDefinitionResponse,
  TaskTypeEnum,
} from 'src/api/ProactApiClient';

export interface CreateTaskRequestOptions {
  taskType: TaskTypeEnum;
  featureFields: TaskDefinitionRequest;
  sourceFormId?: number;
  transitionFields?: TaskDefinitionRequest;
}

export const buildCreateTaskRequest = ({
  taskType,
  featureFields,
  sourceFormId,
  transitionFields,
}: CreateTaskRequestOptions): TaskDefinitionRequest => ({
  content: '',
  ...featureFields,
  taskType,
  active: true,
  sourceFormId,
  ...transitionFields,
});

const persistedTaskFields = (
  item: TaskDefinitionResponse
): TaskDefinitionRequest => ({
  completionType: item.completionType,
  approvalFlowType: item.approvalFlowType,
  subject: item.subject,
  content: item.content,
  contentPdfUrl: item.contentPdfUrl,
  issue: item.issue,
  solution: item.solution,
  dueInDays: item.dueInDays,
  refresh: item.refresh,
  formDefinitionId: item.formDefinitionId,
  assetId: item.assetId,
  projectId: item.projectId,
});

export interface ExistingTaskRequestOptions {
  item: TaskDefinitionResponse;
  featureFields: TaskDefinitionRequest;
  transitionFields?: TaskDefinitionRequest;
}

export const buildEditTaskRequest = ({
  item,
  featureFields,
  transitionFields,
}: ExistingTaskRequestOptions): TaskDefinitionRequest => ({
  ...persistedTaskFields(item),
  documentId: item.documentId,
  documentVersion: item.documentVersion,
  inlineAttachments: item.metadata?.inlineAttachments,
  ...featureFields,
  id: item.id,
  version: item.version,
  instanceId: item.instanceId,
  taskType: item.taskType,
  active: item.active,
  demonstrationId: item.demonstrationId,
  sourceFormId: item.sourceFormId,
  workflowId: item.workflowId,
  workflowActionId: item.workflowActionId,
  ...transitionFields,
});

export const buildCloneTaskRequest = ({
  item,
  featureFields,
  transitionFields,
}: ExistingTaskRequestOptions): TaskDefinitionRequest => ({
  ...persistedTaskFields(item),
  ...featureFields,
  instanceId: item.instanceId,
  taskType: item.taskType,
  active: item.active,
  demonstrationId: item.demonstrationId,
  sourceFormId: item.sourceFormId,
  workflowId: item.workflowId,
  workflowActionId: item.workflowActionId,
  ...transitionFields,
});
